package com.yet.tetris.domain.model.effects

enum class IntensityLevel {
    LOW,
    HIGH,
}
